export const isPressSignup = (searchParams: URLSearchParams): boolean =>
  searchParams.get('src')?.toLowerCase() === 'press';
